import { useMemo } from "react";

import { ModuleSpec } from "src/api/modulesApi";
import { McpModuleConfig, ModuleKind } from "src/clients/flow-api";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const readMcpEnabled = (spec: ModuleSpec | null | undefined): boolean =>
  (spec?.config as McpModuleConfig | undefined)?.mcp_enabled ?? false;

export const useIsMcpModuleEnabled = (): { isEnabled: boolean } => {
  const { modules } = useWorkspaceContext();

  const isEnabled = useMemo(
    () =>
      modules?.some(
        (m) => m.kind === ModuleKind.MCP && readMcpEnabled(m.spec),
      ) ?? false,
    [modules],
  );

  return { isEnabled };
};
